// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoSettings_root__KoI3u"};